import React from "react";

export default class Advertise extends React.Component {
    render() {
        return(
            <div>Advertise</div>
        )
    };
}